import React from "react";
import { useLang } from "../LangContext";

const COPY = {
  sv: {
    title: "Betalningen avbröts",
    body:
      "Din tid är inte bokad och inget belopp har dragits. Du kan välja att försöka igen eller boka utan betalning.",
    retry: "Tillbaka till bokning",
  },
  en: {
    title: "Payment cancelled",
    body:
      "Your appointment was not booked and no amount was charged. You can try again or book without paying.",
    retry: "Back to booking",
  },
};

export default function PaymentCancelled() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.sv;
  return (
    <main className="min-h-screen bg-cream text-ink py-24 px-6 flex items-center">
      <div className="max-w-xl mx-auto" data-testid="pay-cancelled">
        <p className="eyebrow text-ink2 mb-4">— Stripe</p>
        <h1 className="headline text-4xl md:text-5xl mb-6">{c.title}</h1>
        <p className="text-base text-ink2 leading-relaxed mb-10">{c.body}</p>
        <a
          href="/#contact"
          className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-ink text-cream text-sm"
        >
          {c.retry} →
        </a>
      </div>
    </main>
  );
}
